import { z } from 'zod';

export const formSchema = z.object({
  justificationId: z.string({
    required_error: 'Selecione a justificativa',
  }),
  reason: z
    .string({
      required_error: 'Campo obrigatório',
    })
    .trim()
    .min(1, 'Campo obrigatório'),
});

export type FormSchema = z.infer<typeof formSchema>;
